import { render } from "./Conclusao.vue?vue&type=template&id=e694c928&ts=true"
import script from "./Conclusao.vue?vue&type=script&lang=ts"
export * from "./Conclusao.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__